import React from "react";
import { Navbar as BSNavbar, Container, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "../styles/Navbar.css"; // import your CSS

const Navbar = () => {
  return (
    <BSNavbar bg="dark" variant="dark" expand="lg" className="navbar shadow-sm">
      <Container>
        <BSNavbar.Toggle aria-controls="main-nav" />
        <BSNavbar.Collapse id="main-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/about">About</Nav.Link>
            <Nav.Link as={NavLink} to="/" end>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/cart">Cart</Nav.Link>
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default Navbar;
